<template>
  <pokemon-dex-info-modal
      :isOpen="pokedexInfoIsOpen"
      :pokemonId="currentPokemon.pokedexId"
      @update:isOpen="
      pokedexInfoIsOpen = $event;
      $emit('update:isOpen', !$event);
    "
  >
  </pokemon-dex-info-modal>
  <modal :is-open="teamSlotDialogIsOpen" :closeable="false">
    <div v-if="value">
      <Multiselect
          style="width: 80%; margin: auto"
          v-model="value"
          :options="options"
          :show-labels="false"
          :searchable="false"
          :allow-empty="false"
          v-bind:placeholder="value.name"
          track-by="id"
          label="name"
          @close="changeActiveTeam(value)"
      />

      <div class="row p-4">
        <div
            class="col-4 pokemon-list__entry"
            v-for="(slot, value) in slotChecker"
            v-bind:key="slot"
        >
          <PokemonEntryButton
              v-if="slot[value].pokemon"
              :pokedex-id="allPokemon[slot[value].slot].pokedexId"
              :id="allPokemon[slot[value].slot].id"
              :name="allPokemon[slot[value].slot].name"
              :is-shiny="allPokemon[slot[value].slot].isShiny"
              :sell-price="allPokemon[slot[value].slot].sellPrice"
              :lvl="allPokemon[slot[value].slot].lvl"
              :hpPercent="allPokemon[slot[value].slot].hpPercent"
              :team-slot="allPokemon[slot[value].slot].teamSlot"
              :status-effect="allPokemon[slot[value].slot].statusEffect"
              @click="
              teamSlotDialogIsOpen = false;
              addToTeam(value);
            "
          />

          <div v-else>
            <button
                class="btn btn-link add-to-team"
                @click="
                teamSlotDialogIsOpen = false;
                addToTeam(value);
              "
            >
              <svg viewBox="0 0 24 24" class="add-to-team-svg">
                <path
                    fill="#6c757d"
                    d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="teamSlotDialogIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal :is-open="moveModalIsOpen" :closeable="false">
    <div>
      <h3>
        {{ currentSelectedMoveData.name }}
      </h3>
      <div>
        {{ currentSelectedMoveData.description }}
      </div>
      <br/>

      <div>{{ currentSelectedMoveData.damage_class }} move</div>
      <br/>

      <div>Power: {{ currentSelectedMoveData.power }}</div>

      <div>PP: {{ currentSelectedMoveData.pp }}</div>

      <div v-if="currentSelectedMoveData.accuracy !== 0">
        Accuracy: {{ currentSelectedMoveData.accuracy }}%
      </div>
      <div v-else>Accuracy: -</div>

      <br/>

      <div v-if="currentSelectedMoveData.stat_chance > 0">
        Stat Chance: {{ currentSelectedMoveData.stat_chance }}%
      </div>

      <div v-if="currentSelectedMoveData.effect_chance > 0">
        Effect Chance: {{ currentSelectedMoveData.effect_chance }}%
      </div>

      <div v-if="currentSelectedMoveData.priority !== 0">
        Priority: {{ currentSelectedMoveData.priority }}
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="moveModalIsOpen = false"
      >
        {{ translation.general.back }}
      </button>
    </template>
  </modal>

  <modal :is-open="tradeDialogIsOpen" :closeable="false">
    <div>
      <span
          v-html="
          translation.pokemonList.tradeConfirmMessage(
            currentPokemon.name,
            currentPokemon.lvl
          )
        "
      ></span>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-warning pokeinfo-footer__sell"
          @click="
          tradeDialogIsOpen = false;
          wonderTrade(currentPokemon);
        "
      >
        {{ translation.pokemonList.wondertrade }}
      </button>
      <button
          type="button"
          class="btn btn-secondary"
          @click="tradeDialogIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal :is-open="sellDialogIsOpen" :closeable="false">
    <div>
      <span
          v-html="
          translation.pokemonList.sellConfirmMessage(
            currentPokemon.name,
            currentPokemon.lvl
          )
        "
      ></span>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-warning pokeinfo-footer__sell"
          @click="confirmSell"
      >
        {{ translation.pokemonList.sell(currentPokemon.sellPrice) }}
      </button>
      <button
          type="button"
          class="btn btn-secondary"
          @click="sellDialogIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal :is-open="sellSuccessDialogIsOpen" :closeable="false">
    <div>
      {{ translation.pokemonList.sellSuccess }}
    </div>
    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="
          $emit('pokemon-sold', currentPokemon.id);
          sellSuccessDialogIsOpen = false;
        "
      >
        {{ translation.general.okay }}
      </button>
    </template>
  </modal>

  <ItemModal
      :is-open="itemDialogIsOpen"
      @update:is-item-modal-open="itemDialogIsOpen = $event"
      @update:is-pokemon-info-open="$emit('update:is-open', $event)"
      :pokemon="currentPokemon"
      @usedItem="$emit('usedItem')"
  />

  <modal
      :is-open="
      isOpen &&
      !sellDialogIsOpen &&
      !tradeDialogIsOpen &&
      !teamSlotDialogIsOpen &&
      !moveModalIsOpen
    "
      @update:is-open="$emit('update:is-open', $event)"
      :auto-padding="false"
  >
    <div class="pokeinfo-header" :style="headerStyle">
      <div class="pokeinfo-header__background"></div>
      <div class="pokeinfo-header__sprite" :style="spriteStyle"></div>


      <h3 class="pokeinfo-header__id" @click="
          pokedexInfoIsOpen = true;
          $emit('update:is-open', false);
        ">#{{ currentPokemon.order }}</h3>


      <h3
          v-if="!currentPokemon.isBuddy"
          class="pokeinfo-header__buddy"
          @click="
          $emit('buddy-changed', currentPokemon.id);
          setBuddy(currentPokemon.id);
        "
      >
        🤍
      </h3>
      <h3
          v-else
          class="pokeinfo-header__buddy"
          @click="
          $emit('buddy-changed', currentPokemon.id);
          setBuddy(currentPokemon.id);
        "
      >
        💗
      </h3>


      <div class="pokeinfo-header__type">
        <div :class="'pokeinfo-header__type--' + currentPokemon.type2">
          <div></div>
        </div>
        <div :class="'pokeinfo-header__type--' + currentPokemon.type1">
          <div></div>
        </div>
      </div>
      <h3 class="pokeinfo-header__name text-center">

        <div @click="startEditNickname" id="pokemonNickname">
          <p v-if="currentPokemon.nickname">{{ currentPokemon.nickname }}</p>
          <p v-else>{{ currentPokemon.name }}</p>

        </div>
        <input
            style="width: 80%"
            type="text"
            id="pokemonNicknameInput"
            name="pokemonName"
            class="d-none"
            v-bind:value="currentPokemon.nickname"
            @change="
            updateNickname();
            $emit('pokemon-nickname-changed', currentPokemon.id, nickname);
          "
        />

        <span v-if="currentPokemon.isShiny">✨</span><span
          v-if="currentPokemon.pokedexId > 100000">🎇</span><span
          v-else-if="currentPokemon.specialVariant === 1">🎇</span><span
          v-if="currentPokemon.specialVariant === 2">🏆</span>

      </h3>

      <div
          class="pokeinfo-header__health pokeinfo-header__health--dmg text-center"
      >
        {{ currentPokemon.hp }}/{{ currentPokemon.maxHp }} HP
      </div>
      <div class="pokeinfo-header__health text-center">
        {{ currentPokemon.hp }}/{{ currentPokemon.maxHp }} HP
      </div>

      <div class="pokeinfo-header__xp text-center">
        LVL. {{ currentPokemon.lvl }}
      </div>
    </div>

    <div style="border-bottom: 1px solid #dee2e6;height:35px;">
      <div style="margin:auto;width:80%;display: flex;text-align: center;margin-top:5px;">

        <h2 class="pokeinfo-header__use_items" @click="openItemUsageDialogue" style="width: 33%;">
          !
        </h2>

        <h2 class="pokeinfo-header__use_items" @click="pokedexInfoIsOpen = true;$emit('update:is-open', false);"
            style="width: 33%;">
          ?
        </h2>

        <h2
            v-if="!currentPokemon.publicBattleBanned"
            class="pokeinfo-header__add_to_team" style="width: 33%;"
            @click="loadTeam"
        >
          ⚔
        </h2>
        <h2 v-else class="pokeinfo-header__banned" @click="loadTeam">⛔</h2>


        <h3
            v-if="currentPokemon.locked"
            class="pokeinfo-header__lock" style="width: 33%;"
            @click="
          lockPokemon(currentPokemon.id);
        ">
          🔒
        </h3>
        <h3
            v-else
            class="pokeinfo-header__lock" style="width: 33%;"
            @click="
          lockPokemon(currentPokemon.id);
        ">
          ⚠
        </h3>


      </div>


    </div>

    <div class="pokeinfo-body">
      <div style="display: flex;">
        <h5 style="width:50%;">{{ translation.pokemonList.stats }}:</h5>
        <h5 style="width:40%;text-align: right">⌀ IV: {{ currentPokemon.avgIv }}</h5>
      </div>

      <table class="table table-sm" :style="pcgThemeStyle">
        <thead>
        <tr>
          <th scope="col">{{ translation.pokemonList.name }}</th>
          <th scope="col" class="text-right">
            {{ translation.general.value }}
          </th>
          <th scope="col" class="text-center">IV</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ translation.pokemonList.hp }}</td>
          <td class="text-right">{{ currentPokemon.maxHp }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.hpIv
                "
              >
                {{ translation.pokemonList[currentPokemon.hpIv] }}
              </span>
          </td>
        </tr>
        <tr>
          <td
              v-if="currentPokemon.statDown === 'attack'"
              style="color: #00a4ff"
          >
            {{ translation.pokemonList.attack }} (-)
          </td>
          <td
              v-else-if="currentPokemon.statUp === 'attack'"
              style="color: #ea2727"
          >
            {{ translation.pokemonList.attack }}  (+)
          </td>
          <td v-else>{{ translation.pokemonList.attack }}</td>

          <td class="text-right">{{ currentPokemon.attack }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.attackIv
                "
              >
                {{ translation.pokemonList[currentPokemon.attackIv] }}
              </span>
          </td>
        </tr>
        <tr>
          <td
              v-if="currentPokemon.statDown === 'special_attack'"
              style="color: #00a4ff"
          >
            {{ translation.pokemonList.specialAttack }} (-)
          </td>
          <td
              v-else-if="currentPokemon.statUp === 'special_attack'"
              style="color: #ea2727"
          >
            {{ translation.pokemonList.specialAttack }}  (+)
          </td>
          <td v-else>{{ translation.pokemonList.specialAttack }}</td>

          <td class="text-right">{{ currentPokemon.specialAttack }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.specialAttackIv
                "
              >
                {{ translation.pokemonList[currentPokemon.specialAttackIv] }}
              </span>
          </td>
        </tr>
        <tr>
          <td
              v-if="currentPokemon.statDown === 'defense'"
              style="color: #00a4ff"
          >
            {{ translation.pokemonList.defense }} (-)
          </td>
          <td
              v-else-if="currentPokemon.statUp === 'defense'"
              style="color: #ea2727"
          >
            {{ translation.pokemonList.defense }} (+)
          </td>
          <td v-else>{{ translation.pokemonList.defense }}</td>

          <td class="text-right">{{ currentPokemon.defense }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.defenseIv
                "
              >
                {{ translation.pokemonList[currentPokemon.defenseIv] }}
              </span>
          </td>
        </tr>
        <tr>
          <td
              v-if="currentPokemon.statDown === 'special_defense'"
              style="color: #00a4ff"
          >
            {{ translation.pokemonList.specialDefense }} (-)
          </td>
          <td
              v-else-if="currentPokemon.statUp === 'special_defense'"
              style="color: #ea2727"
          >
            {{ translation.pokemonList.specialDefense }}  (+)
          </td>
          <td v-else>{{ translation.pokemonList.specialDefense }}</td>

          <td class="text-right">{{ currentPokemon.specialDefense }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.specialDefenseIv
                "
              >
                {{ translation.pokemonList[currentPokemon.specialDefenseIv] }}
              </span>
          </td>
        </tr>
        <tr>
          <td
              v-if="currentPokemon.statDown === 'speed'"
              style="color: #00a4ff"
          >
            {{ translation.pokemonList.speed }} (-)
          </td>
          <td
              v-else-if="currentPokemon.statUp === 'speed'"
              style="color: #ea2727"
          >
            {{ translation.pokemonList.speed }}  (+)
          </td>
          <td v-else>{{ translation.pokemonList.speed }}</td>

          <td class="text-right">{{ currentPokemon.speed }}</td>
          <td class="text-center">
              <span
                  :class="
                  'pokeinfo-body__stat pokeinfo-body__stat--' +
                  currentPokemon.speedIv
                "
              >
                {{ translation.pokemonList[currentPokemon.speedIv] }}
              </span>
          </td>
        </tr>
        </tbody>
      </table>

      <h5>{{ translation.pokemonList.moves }}</h5>

      <div
          class="row"
          v-if="currentPokemon.moves.length === 4"
          style="border-bottom: 1px solid #dee2e6"
      >
        <button
            class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn"
            @click="getMoveData(currentPokemon.moves[0])"
            style="opacity: 0.9"
        >
          <div
              class="battle-move-btn__type"
              :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  currentPokemon.moves[0].type +
                  '.svg') +
                ')',
            }"
          ></div>

          {{ currentPokemon.moves[0].name }}
          <br/>
          <span style="color: white">
            {{ currentPokemon.moves[0].pp }} /
            {{ currentPokemon.moves[0].max_pp }}</span
          >
        </button>

        <button
            class="btn battle-btn col-5 mr-auto battle-move-btn"
            @click="getMoveData(currentPokemon.moves[1])"
            style="opacity: 0.9"
        >
          <div
              class="battle-move-btn__type"
              :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  currentPokemon.moves[1].type +
                  '.svg') +
                ')',
            }"
          ></div>

          {{ currentPokemon.moves[1].name }}
          <br/>
          <span style="color: white">
            {{ currentPokemon.moves[1].pp }} /
            {{ currentPokemon.moves[1].max_pp }}</span
          >
        </button>
        <button
            class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn"
            @click="getMoveData(currentPokemon.moves[2])"
            style="opacity: 0.9"
        >
          <div
              class="battle-move-btn__type"
              :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  currentPokemon.moves[2].type +
                  '.svg') +
                ')',
            }"
          ></div>

          {{ currentPokemon.moves[2].name }}
          <br/>
          <span style="color: white">
            {{ currentPokemon.moves[2].pp }} /
            {{ currentPokemon.moves[2].max_pp }}</span
          >
        </button>
        <button
            class="btn battle-btn col-5 mr-auto battle-move-btn"
            @click="getMoveData(currentPokemon.moves[3])"
            style="opacity: 0.9"
        >
          <div
              class="battle-move-btn__type"
              :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  currentPokemon.moves[3].type +
                  '.svg') +
                ')',
            }"
          ></div>

          {{ currentPokemon.moves[3].name }}
          <br/>
          <span style="color: white">
            {{ currentPokemon.moves[3].pp }} /
            {{ currentPokemon.moves[3].max_pp }}</span
          >
        </button>
      </div>
      <div v-else>{{ translation.pokemonList.movesNotFound }}!</div>
      <br/>

      <h5>{{ translation.pokemonList.info }}</h5>
      {{ currentPokemon.description }}

      <div class="container">
        <div class="mt-3 row">
          <div class="col-9 p-0">
            <span class="font-weight-bold">{{
                translation.pokemonList.caughtBy
              }}</span
            >:
            <span v-if="currentPokemon.originalOwner">{{
                currentPokemon.originalOwner
              }}</span>
            <span v-else>???</span>

            <br>
            <span class="font-weight-bold">{{
                translation.pokemonList.originalChannel
              }}</span
            >:
            <span v-if="!currentPokemon.originalChannel">???</span>
            <span
                v-else-if="currentPokemon.originalChannel === 'Elementary Raid'"
            >
              <a
                  href="https://docs.google.com/document/d/1BBM7wxpWi9T6Oj9yFafZ4uOUW-l0q4peb7-Y0BcX438"
                  target="_blank"
              >
                {{ currentPokemon.originalChannel }}</a
              >
            </span>
            <span
                v-else-if="
                currentPokemon.originalChannel === 'Halloween Raid 2020'
              "
            >
              <a
                  href="https://docs.google.com/document/d/1snFMMDBjJDMqnic7Ydyh7u3GPnVcDjboBYSVyj8HDvQ"
                  target="_blank"
              >
                {{ currentPokemon.originalChannel }}</a
              >
            </span>
            <span
                v-else-if="currentPokemon.originalChannel === 'Winter Raid 2020'"
            >
              <a
                  href="https://docs.google.com/document/d/1qcfVFFVyzQmiHMNf-3_di5hrBf6aTqT3IUA489Rf-io"
                  target="_blank"
              >
                {{ currentPokemon.originalChannel }}</a
              >
            </span>
            <span
                v-else-if="currentPokemon.originalChannel === 'Sinister Sun Raid'"
            >
              <a
                  href="https://docs.google.com/document/d/19Jxx2Ahw1K9B28AWP84Qo0_QkOK-IGAIMrjDxK9XX8w"
                  target="_blank"
              >
                {{ currentPokemon.originalChannel }}</a
              >
            </span>
            <span
                v-else-if="currentPokemon.originalChannel === 'Easter Event 2021'"
            >
              <a
                  href="https://discord.com/channels/711921837503938640/711930234743816213/825347359676432404"
                  target="_blank"
              >
                {{ currentPokemon.originalChannel }}</a
              >
            </span>
            <span v-else>
              <a
                  v-bind:href="
                  'https://www.twitch.tv/' + currentPokemon.originalChannel
                "
                  target="_blank"
              >{{ currentPokemon.originalChannel }}</a
              >
            </span>

            <div class="align-self-center mr-auto">
              <tooltip direction="top" v-if="currentPokemon.caughtAt !== null">
            <span class="font-weight-bold">{{
                translation.pokemonList.caughtOn
              }}: </span
            >
                <span>
              {{
                    translation.pokemonList.caughtAtFormat(
                        currentPokemon.caughtAt.year,
                        currentPokemon.caughtAt.month,
                        currentPokemon.caughtAt.day
                    )
                  }}
            </span>
                <template #tooltip> Europe/Berlin</template>
              </tooltip>
              <span v-else> ??? </span>
            </div>
          </div>


          <div class="col-3 pl-3 pr-1">
            <tooltip>
              <img
                  :src="`${imageUri}static/twitchextension/img/balls/${currentPokemon.ballType.type}.svg`"
                  class="img-fluid pokeinfo-footer__caught-using-ball"
                  alt="ball"
              />
              <template #tooltip>
                {{ currentPokemon.ballType.name }}
              </template>
            </tooltip>
          </div>
        </div>

      </div>
    </div>

    <template #footer>


      <div v-if="!currentPokemon.tradable">
        <button
            type="button"
            class="btn btn-warning pokeinfo-footer__sell"
            @click="tradeDialogIsOpen = true" :disabled="currentPokemon.locked"
        >
          {{ translation.pokemonList.trade }}
        </button>
      </div>

      <div v-else>
        <tooltip direction="top">
          <button
              type="button"
              class="btn btn-warning pokeinfo-footer__sell"
              disabled
          >
            {{ translation.pokemonList.trade }}
          </button>
          <template #tooltip>
            {{ translation.pokemonList.tradeCooldown(currentPokemon.tradable) }}
          </template>
        </tooltip>
      </div>

      <button
          type="button"
          class="btn btn-warning pokeinfo-footer__sell"
          @click="sellDialogIsOpen = true"
          :disabled="currentPokemon.locked"
      >
        {{ translation.pokemonList.sell(currentPokemon.sellPrice) }}
      </button>

      <button
          type="button"
          class="btn btn-secondary"
          @click="$emit('update:is-open', false)"
      >
        {{ translation.general.back }}
      </button>
    </template>
  </modal>
</template>

<script>
import PokemonDexInfoModal from "../../components/PokemonDexInfoModal/PokemonDexInfoModal.vue";
import Modal from "@/components/Modal/Modal";
import {getAnimatedSprite} from "@/utils/pokesprites";
import {computed, ref} from "@vue/reactivity";
import {translation} from "@/utils/translations";
import {backendUri, imageUri} from "@/utils/settings";
import Tooltip from "@/components/Tooltip/Tooltip";
import axios from "axios";
import {
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {showModalMsg} from "@/components/Modal/modalUtils";
import $ from "jquery";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import {handleUnknownError, sort_by} from "@/utils/utilities";
import Multiselect from "vue-multiselect";
import {PCGApi} from "../../services/pcg";
import ItemModal from "../../components/ItemModal/ItemModal.vue";
import {pcgThemeStyle} from "../../utils/globals";

export default {
  name: "InfoPanel",
  components: {
    Tooltip,
    Modal,
    PokemonEntryButton,
    Multiselect,
    ItemModal,
    PokemonDexInfoModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentPokemon: {
      type: Object,
    },
  },
  emits: [
    "pokemonSold",
    "update:is-open",
    "pokemon-nickname-changed",
    "wonder-trade",
    "buddy-changed",
    "pokemon-sold",
    "usedItem",
    "lock-changed"
  ],
  setup: function (props, {emit}) {
    let value = ref(null);
    let options = ref([]);

    const spriteStyle = computed(() => {
      return {
        backgroundImage:
            "url('" +
            getAnimatedSprite(
                props.currentPokemon.pokedexId,
                props.currentPokemon.isShiny
            ) +
            "')",
      };
    });
    const headerStyle = computed(() => ({
      "--hp-percent": props.currentPokemon.hpPercent + "%",
      "--lvl-percent": props.currentPokemon.lvlPercent + "%",
    }));

    const startEditNickname = async () => {
      $("#pokemonNicknameInput").removeClass("d-none");
      $("#pokemonNickname").addClass("d-none");
    };
    const setBuddy = async (pokemon_id) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-set-buddy/", {
            pokemon_id: pokemon_id,
          })
          .then(() => {
            $(".pokeinfo-header__buddy").text("💗");
          })
          .catch((error) => {
            if (error.response.data.error === 3) {
              showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    const lockPokemon = async (pokemon_id) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-set-lock/", {
            pokemon_id: pokemon_id,
          })
          .then(resp => {
            if (resp.data.locked) {
              $(".pokeinfo-header__lock").text("🔒");
            } else {
              $(".pokeinfo-header__lock").text("⚠");
            }

            emit(
                "lock-changed",
                props.currentPokemon.id,
                resp.data.locked
            );

          })
          .catch((error) => {
            if (error.response.data.error === 3) {
              showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    const currentSelectedMoveData = ref({});
    const getMoveData = async (move) => {
      startLoadingProcess();
      await axios
          .get(backendUri + "api/game/ext/get-move-data/?move=" + move.id)
          .then((resp) => {
            currentSelectedMoveData.value = resp.data;

            moveModalIsOpen.value = true;
          })
          .catch((error) => {
            handleUnknownError(error);
          });
      stopLoadingProcess();
    };

    const moveModalIsOpen = ref(false);

    let nickname = ref("");
    const editNickname = ref(false);
    const updateNickname = async () => {
      nickname.value = $("#pokemonNicknameInput").val();
      // todo auto refresh normal list
      await axios
          .post(
              backendUri +
              "api/game/ext/trainer/change-nickname/" +
              props.currentPokemon.id +
              "/",
              {nickname: nickname.value}
          )
          .then((resp) => {
            nickname.value = resp.data.nickname;
            $("#pokemonNickname").text(nickname.value);
            emit(
                "pokemon-nickname-changed",
                props.currentPokemon.id,
                nickname.value
            );
            $("#pokemonNickname").removeClass("d-none");
            $("#pokemonNicknameInput").addClass("d-none");
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.PokemonNicknameTooLong);
            } else {
              handleUnknownError(error);
            }
          });
    };

    const tradeDialogIsOpen = ref(false);
    const sellDialogIsOpen = ref(false);
    const sellSuccessDialogIsOpen = ref(false);
    const confirmSell = async () => {
      sellDialogIsOpen.value = false;
      emit("update:is-open", false);
      startLoadingProcess();
      await axios
          .post(
              backendUri +
              "api/game/ext/trainer/sell-pokemon/" +
              props.currentPokemon.id +
              "/",
              {sell_price: props.currentPokemon.sellPrice}
          )
          .then(() => {
            sellSuccessDialogIsOpen.value = true;
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.sellNotExists);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.sellNotYourPokemon);
            } else if (error.response.data.error === 3) {
              showModalMsg(translation.pokemonList.sellLast);
            } else if (error.response.data.error === 4) {
              showModalMsg(translation.pokemonList.sellPriceChanged);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    const wonderTrade = async (pkm) => {
      startLoadingProcess();

      try {
        const response = await PCGApi.Trainer.wonderTrade(pkm.id);
        stopLoadingProcess();

        emit("wonder-trade", response.pokemon);
        return;
      } catch (error) {
        if (error.response.data.error === 1) {
          showModalMsg(translation.pokemonList.sellNotExists);
        } else if (error.response.data.error === 2) {
          showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
        } else if (error.response.data.error === 3) {
          showModalMsg(translation.pokemonList.tradeCooldownIsActive);
        } else {
          handleUnknownError(error);
        }
      }

      stopLoadingProcess();
    };

    const addToTeam = async (slot) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-set-team-new/", {
            pokemon_id: props.currentPokemon.id,
            slot: slot,
          })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.PokemonAlreadyInTeam);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.PokemonTeamFull);
            } else if (error.response.data.error === 3) {
              showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    let slotChecker = ref([]);
    const allPokemon = ref([]);
    let teamSlotDialogIsOpen = ref(false);
    const loadTeam = async () => {
      startLoadingProcess();
      teamSlotDialogIsOpen.value = true;
      await axios
          .get(backendUri + "api/game/ext/trainer/pokemon-team-list/")
          .then((resp) => {
            allPokemon.value = resp.data.allPokemon;
            allPokemon.value.sort(sort_by("teamSlot", false));

            options.value = [];
            for (let i = 0; i < resp.data.teamNames.length; i++) {
              options.value.push({id: i, name: resp.data.teamNames[i]});
            }
            value.value = options.value[resp.data.teamNumber];

            let tmp = [];
            let slot = 0;
            for (var i = 0; i < 6; i++) {
              let dict = {};
              for (var j = 0; j < allPokemon.value.length; j++) {
                if (allPokemon.value[j].teamSlot === i) {
                  dict[i] = {pokemon: true, slot: slot};
                  tmp.push(dict);
                  slot += 1;
                }
              }
              if (tmp.length !== i + 1) {
                dict[i] = {pokemon: false};
                tmp.push(dict);
              }
            }
            slotChecker.value = tmp;
          })
          .catch((error) => {
            handleUnknownError(error);
          });
      stopLoadingProcess();
    };

    const changeActiveTeam = async (team) => {
      console.log(team.id);
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-change-active-team/", {
            team_id: team.id,
          })
          .then(() => {
            loadTeam();
          })
          .catch((error) => {
            handleUnknownError(error);
          });
    };

    const itemDialogIsOpen = ref(false);

    const openItemUsageDialogue = () => {
      itemDialogIsOpen.value = true;
      emit("update:is-open", false);
    };

    const pokedexInfoIsOpen = ref(false);

    return {
      translation,
      backendUri,
      imageUri,
      spriteStyle,
      headerStyle,
      sellDialogIsOpen,
      sellSuccessDialogIsOpen,
      confirmSell,
      updateNickname,
      editNickname,
      startEditNickname,
      nickname,
      tradeDialogIsOpen,
      setBuddy,
      teamSlotDialogIsOpen,
      loadTeam,
      allPokemon,
      addToTeam,
      changeActiveTeam,
      slotChecker,
      value,
      options,
      moveModalIsOpen,
      getMoveData,
      currentSelectedMoveData,
      wonderTrade,
      openItemUsageDialogue,
      itemDialogIsOpen,
      pokedexInfoIsOpen,
      pcgThemeStyle,
      lockPokemon,
    };
  },
};
</script>

<style lang="scss" src="./scss/info-panel-header.scss" scoped></style>
<style lang="scss" src="./scss/info-panel-body.scss" scoped></style>

<style lang="scss" scoped>
.battle-move-btn {
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 10px;
}

.battle-move-btn__type {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 0;
  right: 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.7;
  z-index: -5;
}

.battle-btn {
  background: linear-gradient(to right, rgb(203, 45, 62), rgb(239, 71, 58));
  color: white;
  border: none;
  transition: all 500ms;
}

.battle-btn .text-muted {
  color: rgba(255, 255, 255, 0.67) !important;
}

.battle-btn:hover {
  color: white;
}

.battle-btn:not([disabled]):hover {
  box-shadow: #cb2d3e 0 0 20px;
}

.pokeinfo-footer {
  &__sell {
    background: linear-gradient(to right, rgb(255, 189, 42), rgb(255, 202, 53));
  }

  &__caught-using-ball {
    max-height: 48px;
  }

  &__caught-at {
    color: #b5b5b5;
  }
}

.add-to-team {
  transition: all 600ms ease;
  transform: rotate(0deg);

  width: 68px;
  height: 68px;

  svg {
    position: absolute;
    top: 12px;
    left: 0;
    transition: all 600ms ease;
  }

  &:hover &-svg {
    transform: rotate(90deg);
  }
}
</style>
